import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch, Route, Redirect } from 'react-router-dom'
import { compose } from 'recompose'

import getQueryStringFromURL from 'libs/get-query-string-value'
import { connectApi } from 'libs/connectApi'
import { canCreateSurvey } from './utils'

import { SurveySettings } from '../SurveySettings'
import SurveyContainer from 'components/Admin/Surveys/container'

class AdminSurveys extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object,
  }

  render() {
    const isCreate = this.props.location.search
      ? getQueryStringFromURL(this.props.location.search, 'create') === 'true'
      : false

    return (
      <Switch>
        <Route exact path="/:workspaceToken/settings/surveys/">
          <SurveyContainer
            isCreate={isCreate}
            userLoading={this.props.user.loading}
            canCreateSurvey={canCreateSurvey(this.props.user.data)}
          />
        </Route>
        <Route path={'/:workspaceToken/settings/surveys/:surveyId/'} component={SurveySettings} />
        <Route render={() => <Redirect to="/404/" />} />
      </Switch>
    )
  }
}

export default compose(
  connectApi({
    name: 'user',
    url: 'account/users/me/v2/',
    schema: '@userInfo',
  }),
  withRouter
)(AdminSurveys)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/AdminSurveys/index.js